import React from 'react';
import PropTypes from 'prop-types';
import {
  IonIcon,
  IonLabel,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonBackButton,
  IonList,
  IonItem,
  IonItemSliding,
  IonItemOptions,
  IonItemOption,
  IonContent,
  IonSpinner,
  IonModal,
  IonButton,
  IonRow,
  IonProgressBar,
  IonCard,
  IonCardTitle,
  IonCardHeader,
  IonCardContent,
  IonAvatar,
  IonImg
} from '@ionic/react';
import { checkboxOutline } from 'ionicons/icons';
import { connect } from 'react-redux'
import { Plugins } from '@capacitor/core';
import { close, documentAttachOutline, cloudUpload } from 'ionicons/icons';
import renderHTML from 'react-render-html';
import { FileChooser } from "@ionic-native/file-chooser";
import {
  FileTransfer,
  FileUploadOptions
} from "@ionic-native/file-transfer";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import GuideActions from '../../../../actions/guide';
import { SERVER_EDU_CODESII, RESOURCES } from '../../../../constants/system';
import ErrorAlert from '../../../../components/ErrorAlert';

interface IProps {
  getTasks: any;
  getTask: any;
  setData: any;
  getTaskInfo: any;
  changeFields: any;
}

interface IState {
  data: any;
  match: any;
  showModal: boolean;
  showModal2: boolean;
  guide: any;
}

const { Browser } = Plugins;
class Guide extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data, match: props.match, showModal:false, showModal2:false, guide: {}}
  }

  componentDidMount(){
    if (this.state.data.tasks.length === 0) {
      this.props.getTasks({code: this.state.match.params.child, evi: this.state.match.params.evi}, "get_child_tasks");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });
  }

  getTask_(guide: any){
    this.props.getTask({guide: guide.nid, alumno: this.state.data.user.nid}, "get_info_guide");

    this.setState({
      showModal: true
    });
  }

  getTask_Info(guide: any){
    this.props.getTaskInfo({item: guide.nid, alumno: this.state.data.user.nid}, this.state.data.fields, "get_entregas");

    this.setState({
      showModal2: true,
      guide: guide
    });
  }

  statusModal(open: boolean){
    if (!open) {
      this.props.setData(null, 'tarea');
      this.props.setData([], 'adjuntos');
    }
    this.setState({
      showModal: open
    });
  }

  statusModal2(open: boolean){
    if (!open) {
      this.props.setData(null, 'entregas');
    }
    this.setState({
      showModal2: open
    });
  }

  getFile(){
    FileChooser.open()
      .then(uri => {
        let fileTransfer = FileTransfer.create();
        let options: FileUploadOptions = {
         fileKey: 'fileToUpload[0]',
         fileName: 'Orderimg.png',
         httpMethod : 'POST',
         mimeType: '*',
         chunkedMode: false,
         headers : {"Accept": "*"}
        }
        fileTransfer.upload(uri, `${ SERVER_EDU_CODESII }edu/local/admin/v1/upload_app/uploadtaskfile` , options).then(
          entry => {
            console.log(JSON.stringify(entry));
          },
          error => {
            console.log("error", error);
          }
        );
      })
      .catch(e => {
        console.log('Error choosing file: ', e);
    });
  }

  handleChangeEditor(content: any) {
    let fields = this.state.data.fields;
    fields.message = content;
    this.props.changeFields(fields)
  }

  render() {
    const { child } = this.state.match.params;
    const { user, tasks, evi, tarea, adjuntos, entregas, fields, error, error401, loading } = this.state.data;
    const { guide } = this.state;
    return (
      <IonPage>
        <ErrorAlert/>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref={`/progress/${ child }/pro`} />
            </IonButtons>
            <IonTitle>{ !error && !error401 && user.alumno ? user.alumno : error || error401 ? "Error en la petición":"Cargando..." }</IonTitle>
          </IonToolbar>
          <IonToolbar className="toolbarTint">
            <IonTitle style={ !error && !error401 && user.alumno ? {display: "block"}: {display: "none"}} className="ion-text-center">{evi.descripcion}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <IonModal isOpen={this.state.showModal} >
            <IonHeader>
              <IonToolbar color="primary">
                <IonButtons slot="end">
                  <IonButton onClick={this.statusModal.bind(this, false)} disabled={loading}>
                    <IonIcon icon={close}/>
                  </IonButton>
                </IonButtons>
                <IonTitle className="ion-text-center">{ tarea ? evi.descripcion : error || error401 ? "Error en la petición" : "Cargando..."}</IonTitle>
              </IonToolbar>
              <IonToolbar className="toolbarTint">
                <IonTitle>{ tarea ? tarea.titulo : ""}</IonTitle>
              </IonToolbar>
            </IonHeader>

            <IonContent>
              <IonProgressBar style={ loading ? {display: 'block'} : {display: 'none'}} type="indeterminate"></IonProgressBar>
              <IonRow style={ error || error401 ? { display: "none" } : { paddingLeft: '10%', paddingRight: '10%' }}>
                {renderHTML(tarea ? tarea.contenido ? tarea.contenido: "" : "")}
              </IonRow>
              <IonRow style={ error || error401 ? { display: "none" } : { display: "block", paddingLeft: '10%', paddingRight: '10%' }}>
                <IonCard style={ loading ? { display:"none" } : { display:"block", width: '100%' } }>
                  <IonCardHeader>
                    <IonCardTitle>Material de estudio</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent>
                    {adjuntos.map((val:any, key:any) => {
                      return (
                        <a key={key} onClick={() => Browser.open({ url: `${ SERVER_EDU_CODESII }public/uploaded/tareas/${ val.strfiles }` })}><IonIcon icon={documentAttachOutline} color="primary" slot="end"/> {val.nombre}</a>
                      );
                    })}
                    <p className="ion-text-center">{adjuntos.length === 0 ? "No hay archivos adjuntos" : ""}</p>
                  </IonCardContent>
                </IonCard>
              </IonRow>
            </IonContent>
          </IonModal>

          <IonModal isOpen={this.state.showModal2} >
            <IonHeader>
              <IonToolbar color="primary">
                <IonButtons slot="end">
                  <IonButton onClick={this.statusModal2.bind(this, false)} disabled={loading}>
                    <IonIcon icon={close}/>
                  </IonButton>
                </IonButtons>
                <IonTitle className="ion-text-center">{ entregas ? evi.descripcion : error || error401 ? "Error en la petición" : "Cargando..."}</IonTitle>
              </IonToolbar>
              <IonToolbar className="toolbarTint">
                <IonTitle>{ entregas ? guide.titulo : "" }</IonTitle>
              </IonToolbar>
            </IonHeader>

            <IonContent>
              <IonProgressBar style={ loading ? {display: 'block'} : {display: 'none'}} type="indeterminate"></IonProgressBar>
              <IonItemSliding style={ error || error401 || loading ? { display:"none" } : { display:"block" } }>
                <IonItem>
                  <IonAvatar slot="start">
                    <IonImg src={`${ RESOURCES }alumnos/${ entregas ? entregas.foto : "" }`}/>
                  </IonAvatar>
                  <IonLabel>
                    <h2>{ entregas ? entregas.alumno : ""}</h2>
                    <p>Nota: { entregas ? entregas.nota : ""}</p>
                    <p>tarea: <a slot="end" onClick={() => Browser.open({ url: `${ RESOURCES }tareas/${ entregas ? entregas.strfile : "" }` })}><IonIcon icon={documentAttachOutline} color="primary" slot="end"/> { entregas ? entregas.nombrefile : ""}</a></p>
                    <p>Fecha limite: { entregas ? entregas.fechafin : ""}</p>
                  </IonLabel>
                  <a slot="end"><IonIcon icon={checkboxOutline} color="primary" slot="end"/></a>
                </IonItem>
                <IonItemOptions side="end">
                  <IonItemOption onClick={this.getFile.bind(this)} color="medium">Subir archivo</IonItemOption>
                </IonItemOptions>
              </IonItemSliding>
              <ReactQuill theme="snow" value={fields.message || ""} onChange={this.handleChangeEditor.bind(this)} style={ error || error401 || loading ? { display:"none" } : { display:"block" } }/>
              <div className="ion-padding">
                <IonButton style={ error || error401 || loading ? { display:"none" } : { display:"block" } } expand="block" type="submit" className="ion-no-margin"><IonIcon icon={cloudUpload} />&nbsp;Actualizar</IonButton>
              </div>
            </IonContent>
          </IonModal>

          <div style={ loading ? {display: "block", paddingTop: '10%'} : {display: "none"}} className="ion-text-center"><IonSpinner name="circles" color="primary"/></div>
          <h1 style={error || error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">Error en el sistema, consulte con el administador de la aplicación.</h1>
          <IonList style={error || error401 && !loading ? {display: "none"} : {display: "block"} }>
            <h1 style={tasks.length === 0 && !error && !error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">No hay registros</h1>
            {tasks.map((val:any, key:any) => {
              return (
                 <IonItemSliding key={key}>
                  <IonItem>
                    <IonLabel>
                      <h2>{key+1}-{val.titulo}</h2>
                      <p>Fecha: {val.fechaadd}</p>
                      <p>Fecha limite: {val.fechafin}</p>
                    </IonLabel>
                    <a slot="end" href={`/progress/${ user.carnet }/pro/${ val.nid }/guide`}><IonIcon icon={checkboxOutline} color="primary" slot="end"/></a>
                  </IonItem>
                  <IonItemOptions side="end">
                    <IonItemOption color="medium" onClick={this.getTask_Info.bind(this, val)}>Adjuntar</IonItemOption>
                    <IonItemOption className="colorMedium" onClick={this.getTask_.bind(this, val)}>Ver</IonItemOption>
                    <IonItemOption onClick={() => Browser.open({ url: `${ SERVER_EDU_CODESII }edu/local/admin/v1/upload_app/print/${ val.nid }/${ user.nid }` })} color="medium">Descargar</IonItemOption>
                  </IonItemOptions>
                </IonItemSliding>
              );
            })}
          </IonList>
        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data,
    getTasks: PropTypes.func.isRequired,
    getTask: PropTypes.func.isRequired,
    getTaskInfo: PropTypes.func.isRequired,
    changeFields: PropTypes.func.isRequired
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getTasks: (fields: any, typeOptions: string) => dispatch(GuideActions.getTasks(fields, typeOptions)),
    getTask: (fields: any, typeOptions: string) => dispatch(GuideActions.getTask(fields, typeOptions)),
    setData: (items: any, name: any) => dispatch(GuideActions.setData(items, name)),
    getTaskInfo: (items: any, fields: any, name: any) => dispatch(GuideActions.getTaskInfo(items, fields, name)),
    changeFields: (fields: any) => dispatch(GuideActions.changeFields(fields)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Guide);
